import React from 'react';

//import Term from '../components/term'

//Replaced by ReactMarkdown besides phase overview
export const parseText = (text, tag) => {
  const CustomTag = `${tag}`;
  //turn \n into defined tags
  let newText = text.split ('\n').map ((item, i) =>
    <CustomTag key={i}>{item}</CustomTag>
  );
  return newText;
}

export const parseTags = (text, tag, delimiter, cls, onclick) => {
  const CustomTag = `${tag}`;
//    console.log(CustomTag);
  //turn csv into defined tags
  let newText = text.split (delimiter).map ((item, i) =>
    <CustomTag
      key={i}
      className={cls}
      onClick={onclick}
    >
      {item}
    </CustomTag>
  );
//    console.log(newText);
  return newText;
}



// WEBPACK FOOTER //
// ./src/functions/functions.js